<template>
  <HeaderComp />

  <div class="wrapper-asset asset-first">
    <div class="title-wrap-asset">
      <h2>ASSET</h2>
      <p>DE HEUS INDONESIA</p>
    </div>
  </div>

  <!-- Drawer Overlay (Mobile) -->
  <div
    v-if="drawerOpen"
    class="drawer-overlay"
    @click="drawerOpen = false"
  ></div>

  <div class="row-box">
    <!-- Column 1: Filter Drawer / Sidebar -->
    <div :class="['column-1', 'filter-drawer', { open: drawerOpen }]">
      <div class="drawer-header" v-if="isMobile">
        <h3>Filter</h3>
        <button class="close-btn" @click="drawerOpen = false">×</button>
      </div>

      <div class="filter-box-asset">
        <h3 v-if="!isMobile">Filter</h3>

        <!-- Asset Filter -->
        <div class="filter-category">
          <div class="filter-header" @click="toggleCategory('asset')">
            <h4>Asset</h4>
            <span>{{ showCategory.asset ? "-" : "+" }}</span>
          </div>
          <transition name="slide">
            <div v-show="showCategory.asset">
              <div
                v-for="asset in assetCategories"
                :key="asset"
                :class="[
                  'filter-item',
                  { active: selectedAssets.includes(asset) },
                ]"
              >
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedAssets"
                    :value="asset"
                  />
                  {{ asset }}
                </label>
              </div>
            </div>
          </transition>
        </div>

        <!-- Kota Filter -->
        <div class="filter-category">
          <div class="filter-header" @click="toggleCategory('kota')">
            <h4>Kota</h4>
            <span>{{ showCategory.kota ? "-" : "+" }}</span>
          </div>
          <transition name="slide">
            <div v-show="showCategory.kota">
              <div
                v-for="kota in kotaList"
                :key="kota"
                :class="[
                  'filter-item',
                  { active: selectedKota.includes(kota) },
                ]"
              >
                <label>
                  <input type="checkbox" v-model="selectedKota" :value="kota" />
                  {{ kota }}
                </label>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- Column 2: Asset List -->
    <div class="column-2">
      <!-- MOBILE FILTER BUTTON -->
      <button
        v-if="isMobile"
        class="filter-toggle-btn"
        @click="drawerOpen = true"
      >
        Filter
      </button>
      <div class="wrapper-blog-asset">
        <h2 class="h2-asset">LIST ASSET</h2>
        <div class="container">
          <div class="wrapper-content-blog">
            <div v-for="item in visibleBlogs" :key="item.slug" class="box">
              <img
                class="cover-image"
                :src="item.cover_image || require('@/assets/images/prop-1.jpg')"
                alt=""
              />
              <div class="b-content">
                <p>
                  <span
                    v-for="tag in item.types.split(',')"
                    :key="tag"
                    class="tag-style"
                  >
                    {{ tag.trim() }}
                  </span>
                  <span
                    v-for="asset in selectedAssets"
                    v-if="item.types.toUpperCase().includes(asset)"
                    :key="asset"
                    class="badge-filter"
                  >
                    {{ asset }}
                  </span>
                  <span
                    v-for="kota in selectedKota"
                    v-if="item.district_name.includes(kota)"
                    :key="kota"
                    class="badge-filter kota"
                  >
                    {{ kota }}
                  </span>
                </p>

                <h5>{{ item.title }}</h5>
                <p class="address">
                  {{ item.subdistrict_name }}, {{ item.district_name }}
                </p>
                <p class="price">
                  Rp {{ Number(item.price).toLocaleString("id-ID") }}
                </p>
                <p class="specs">Luas {{ item.area }} m²</p>
                <router-link :to="`/asset/${item.slug}`" class="btn-detail">
                  DETAIL ASSET
                </router-link>
              </div>
            </div>
          </div>

          <div
            class="wrapper-btn"
            v-if="
              selectedAssets.length === 0 &&
              selectedKota.length === 0 &&
              filteredBlogs.length > visibleCount
            "
          >
            <button @click="loadMore">Selengkapnya..</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <FooterComp />
</template>

<script>
import "../assets/styles/style.css";
import HeaderComp from "@/components/template/HeaderComp.vue";
import FooterComp from "@/components/template/FooterComp.vue";

export default {
  name: "AssetView",
  components: { HeaderComp, FooterComp },
  data() {
    return {
      assetCategories: [], // from API tag
      kotaList: [], // from post-data API

      selectedAssets: [],
      selectedKota: [],

      blogs: [], // data asset from API or dummy

      visibleCount: 8,
      showCategory: { asset: true, kota: true },

      isLoading: true, // loader

      dummyProperties: [
        {
          slug: "dummy-1",
          title: "TANAH 3.615 m²",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          cover_image: require("@/assets/images/prop-1.jpg"),
          types: "TANAH",
        },
        {
          slug: "dummy-2",
          title: "RUMAH MEWAH",
          district_name: "Jakarta Selatan",
          subdistrict_name: "Kebayoran",
          price: "2500000000",
          area: "500",
          cover_image: require("@/assets/images/prop-2.jpg"),
          types: "RUMAH",
        },
        {
          slug: "dummy-3",
          title: "TANAH 3.615 m²",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          cover_image: require("@/assets/images/prop-3.jpg"),
          types: "TANAH",
        },
        {
          slug: "dummy-4",
          title: "RUMAH MEWAH",
          district_name: "Jakarta Selatan",
          subdistrict_name: "Kebayoran",
          price: "2500000000",
          area: "500",
          cover_image: require("@/assets/images/prop-1.jpg"),
          types: "RUMAH",
        },
        {
          slug: "dummy-5",
          title: "TANAH 3.615 m²",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          cover_image: require("@/assets/images/prop-2.jpg"),
          types: "TANAH",
        },
        {
          slug: "dummy-6",
          title: "RUMAH MEWAH",
          district_name: "Jakarta Selatan",
          subdistrict_name: "Kebayoran",
          price: "2500000000",
          area: "500",
          cover_image: require("@/assets/images/prop-3.jpg"),
          types: "RUMAH",
        },
        {
          slug: "dummy-7",
          title: "TANAH 3.615 m²",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          cover_image: require("@/assets/images/prop-1.jpg"),
          types: "TANAH",
        },
        {
          slug: "dummy-8",
          title: "RUMAH MEWAH",
          district_name: "Jakarta Selatan",
          subdistrict_name: "Kebayoran",
          price: "2500000000",
          area: "500",
          cover_image: require("@/assets/images/prop-2.jpg"),
          types: "RUMAH",
        },
        // ... lanjutkan sampai minimal 8 dummy (sudah kamu siapkan)
      ],
      drawerOpen: false,
      isMobile: window.innerWidth <= 768,
    };
  },

  async mounted() {
    window.addEventListener("resize", this.handleResize);
    await this.loadTags();
    await this.loadAssets();
    const city = this.$route.query.city;
    const type = this.$route.query.type;

    if (city) {
      this.selectedKota = [city];
    }

    if (type) {
      this.selectedAssets = [type.toUpperCase()];
    }
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  computed: {
    filteredBlogs() {
      return this.blogs.filter((item) => {
        const matchAsset = this.selectedAssets.length
          ? item.types
              .split(",")
              .some((t) => this.selectedAssets.includes(t.trim().toUpperCase()))
          : true;

        const matchKota = this.selectedKota.length
          ? this.selectedKota.some(
              (sel) =>
                sel.toString().toLowerCase() ===
                  item.district_name.toLowerCase() ||
                sel.toString().toLowerCase() === item.district_id.toLowerCase(),
            )
          : true;

        return matchAsset && matchKota;
      });
    },

    visibleBlogs() {
      const filtering = this.selectedAssets.length || this.selectedKota.length;

      return filtering
        ? this.filteredBlogs
        : this.filteredBlogs.slice(0, this.visibleCount);
    },
  },

  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) this.drawerOpen = false;
    },
    async loadTags() {
      try {
        const res = await fetch("https://cms-property.cjfnc.id/api/tag");
        const json = await res.json();
        this.assetCategories = json.data.map((t) => t.name.toUpperCase());
      } catch (e) {
        console.warn("Tag API error → use fallback");
        this.assetCategories = ["TANAH", "RUMAH", "RUKO"];
      }
    },

    async loadAssets() {
      this.isLoading = true;
      try {
        const res = await fetch("https://cms-property.cjfnc.id/api/post-data");
        const json = await res.json();
        const data = json?.data ?? [];

        if (data.length >= 2) {
          this.blogs = data.map((i) => ({
            slug: i.slug,
            title: i.title,
            district_name: i.district_name,
            subdistrict_name: i.subdistrict_name,
            price: i.price,
            area: i.area,
            cover_image: i.cover_image,
            types: i.types,
            district_id: i.district_id,
          }));

          // Get unique Kota from API data
          this.kotaList = [...new Set(data.map((d) => d.district_name))];
        } else {
          this.blogs = this.dummyProperties;
          this.kotaList = [
            ...new Set(this.dummyProperties.map((d) => d.district_name)),
          ];
        }
      } catch (e) {
        console.error("Asset API error → dummy used");
        this.blogs = this.dummyProperties;
        this.kotaList = [
          ...new Set(this.dummyProperties.map((d) => d.district_name)),
        ];
      } finally {
        this.isLoading = false;
      }
    },

    loadMore() {
      this.visibleCount += 8;
    },

    toggleCategory(cat) {
      this.showCategory[cat] = !this.showCategory[cat];
    },
  },
};
</script>

<style>
.cover-image {
  height: 200px;
  object-fit: cover;
}
.wrapper-asset {
  position: relative;
  background: #006dcd;
  height: 60vh;
}
.asset-first {
  position: relative;
  background-size: cover;
  background-position: bottom;
  background-attachment: fixed;
  clip-path: ellipse(70% 80% at 50% 100%);

  color: #000;
  text-align: center;
}

.title-wrap-asset {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  height: 60vh;
}

.title-wrap-asset h2 {
  font-size: 52px;
  color: #fff !important;
}

.title-wrap-asset p {
  color: #fff !important;
}

.badge-filter {
  background: #ff9600;
  color: #fff;
  padding: 2px 6px;
  margin-right: 4px;
  border-radius: 4px;
  font-size: 12px;
}

.badge-filter.kota {
  background: #006dcd;
}

.row-box {
  display: flex;
  gap: 20px;
  width: 100%;
  position: relative;
}

.column-1 {
  width: 20%;
  height: auto;
  background: #f8f8f8;
  padding: 10px;
  border-right: 1px solid #ddd;
}

.column-2 {
  width: 80%;
}

.filter-box-asset h3 {
  text-align: left;
  margin-bottom: 20px;
}

.filter-box-asset {
  position: sticky;
  top: 80px; /* sesuaikan dengan tinggi header */
  background: #fff;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 8px;
  max-height: calc(100vh - 100px); /* biar tidak lebih tinggi dari layar */
  overflow-y: auto; /* kalau isi filter banyak, bisa discroll */
}

.filter-category {
  margin-bottom: 20px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  background: #f5f5f5;
  padding: 8px 12px;
  border-radius: 5px;
  font-weight: bold;
}

.filter-item {
  padding: 5px 10px;
  border-radius: 5px;
  margin: 2px 0;
  transition: all 0.3s ease;
  text-align: left;
}

.filter-item:hover {
  background: #eee;
}

.filter-item.active {
  background: #ff9600;
  color: #fff;
  font-weight: bold;
}

.filter-header h4 {
  margin: 0;
}

/* ====================== FILTER DRAWER ====================== */
.filter-toggle-btn {
  display: block;
  padding: 10px 15px;
  background: #333;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 15px; /* jarak dari asset list */
  border: none;
}

.drawer-overlay {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.35);
  z-index: 1100;
  animation: fadeIn 0.25s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
}
.filter-drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  height: 100vh;
  background: #fff;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

/* Desktop when open */
.filter-drawer.open {
  transform: translateX(0);
}

.close-btn {
  font-size: 22px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
.slide-enter-to,
.slide-leave-from {
  max-height: 500px; /* cukup tinggi untuk menampung isi filter */
  opacity: 1;
}

.wrapper-blog-asset {
  padding: 50px 0px 70px 0px;
  position: relative;
  z-index: 0;
}

.wrapper-btn {
  margin: 70px 0px 0px 0px;
}

.wrapper-btn button {
  border: 1px solid #303030;
  filter: drop-shadow(10px 10px 40px rgba(164, 164, 164, 0.25));
  border-radius: 50px;
  justify-content: center;
  align-items: center;
  padding: 12px 70px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height, or 24px */
  background: transparent;
  text-align: center;
  text-decoration: none;
  transition: all 0.5s ease;
}
.wrapper-btn button:hover {
  border: 1px solid #ff9600;
  background: #ff9600;
  color: #fff;
  transition: all 0.5s ease;
}

.h2-asset {
  margin-bottom: 30px;
  text-align: left;
  padding-bottom: 10px;
  border-bottom: 1px solid #000;
  margin: 0px 20px 30px 20px;
}

@media (max-width: 768px) {
  .column-1 {
    width: 0;
  }
  .asset-first {
    -webkit-clip-path: ellipse(90% 80% at 50% 100%);
    clip-path: ellipse(90% 80% at 50% 100%);
  }
  .wrapper-content-blog {
    margin-top: 30px;
  }
  .column-2 {
    width: 100%;
  }
  .wrapper-content-blog .box {
    grid-column: span 4;
  }
  .filter-toggle-btn {
    display: block;
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #006dcd;
    color: #fff;
    padding: 14px 22px;
    border: none;
    border-radius: 50px;
    font-size: 15px;
    font-weight: 600;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
    z-index: 1200;
  }
  .filter-drawer {
    position: fixed;
    top: 0;
    right: -100%;
    width: 85%;
    height: 100vh;
    background: #fff;
    z-index: 12010;
    overflow-y: auto;
    padding: 20px;
    border-left: 3px solid #006dcd;
    border-radius: 12px 0 0 12px;
    box-shadow: -5px 0 25px rgba(0, 0, 0, 0.15);
    transition: right 0.33s ease;
    left: auto !important;
    transform: none !important;
    display: block !important;
  }

  .filter-drawer.open {
    right: 0;
  }

  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
  }

  .close-btn {
    font-size: 26px;
    font-weight: bold;
    color: #333;
  }
  .filter-box-asset .filter-item label {
    display: flex;
  }
  .filter-box-asset input[type="checkbox"] {
    display: block;
    margin-right: 10px;
  }
  .wrapper-content-blog {
    margin-top: 30px !important;
  }
}

@media (min-width: 769px) {
  .filter-drawer {
    position: static !important;
    width: 20%;
    height: auto;
    transform: none !important;
    padding: 10px;
  }
  .drawer-overlay {
    display: none !important;
  }
  .filter-toggle-btn {
    display: none;
  }
  .filter-drawer {
    position: static !important;
    width: 20%;
  }
}
</style>
